import { render, staticRenderFns } from "./CompPeopleTourStagesCard.vue?vue&type=template&id=0cb0e515"
import script from "./CompPeopleTourStagesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompPeopleTourStagesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports